export interface ProyectoBusqueda{
    idProyecto: number,
    titulo: string,
    codigo: string,
    idResponsable: number, 
    responsable: string,
    fechaInicio: string,
    fechaFin: string,
    estado: string
  }

  export function GetVoidProyectoBusqueda():ProyectoBusqueda{
    return{
      idProyecto: 0,
      titulo: "",
      codigo: "",
      idResponsable: 0,
      responsable: "",
      fechaInicio: "",
      fechaFin: "",
      estado: ""
    }
  }
